import React from 'react';
import About from './../About/About';
import Cover from './../Cover/Cover';
import MyNavBar from './../MyNavbar/MyNavbar';
import Skill from './../Skill/Skill';
import Experience from './../Experience/Experience';
import Projects from './../Projects/Projects';
import ContactForm from './../../Shared/ContactForm/ContactForm';
import MyFooter from './../../Shared/MyFooter/MyFooter';
import './Home.css';

const Home = () => {
    return (
        <div>
            <MyNavBar></MyNavBar>
            <Cover></Cover>
            <About></About>
            <Skill></Skill>
            <Experience></Experience>
            <Projects></Projects>
            <ContactForm></ContactForm>
            <MyFooter></MyFooter>
        </div>
    );
};

export default Home;